import { DiscoveryPoint, UpsertDiscoveryPoint } from '@/models/discovery-point.model';
import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedDiscoveryPoints = async (input: PaginationFilterRequest): Promise<PagedResponseModel<DiscoveryPoint>> => {
  return await getReq(createUrl("a/DiscoveryPoint/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getDiscoveryPointsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedDiscoveryPoints(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getDiscoveryPoint = async (id: number): Promise<BaseResponseModel<DiscoveryPoint>> => {
  return await getReq(createUrl(`a/DiscoveryPoint/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertDiscoveryPoint = async (input: UpsertDiscoveryPoint): Promise<BaseResponseModel<DiscoveryPoint>> => {
  return await postReq(createUrl("a/DiscoveryPoint/Upsert"),
    input
  ).then((res: any) => res.data);
};
